module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('input', {
    staticClass: "required",
    attrs: {
      "type": "radio",
      "name": "shipping[pickup_location]",
      "id": _vm.inputId
    },
    domProps: {
      "value": _vm.item.id
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.item.name))]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /source/~/vue-loader/lib/template-compiler.js?{"id":"data-v-3503fbb2"}!/source/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickup-locations/item.vue
// module id = 122
// module chunks = 0